export enum ToebBearbeitungStatus {
  Freigabe = 'Freigabe',
  AktivierungAusstehend ='offen Aktivierung'
}
